import { ESize } from 'src/styles/theme/utils/enums';
import { addTransition } from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';
import { ERhombusType } from './NGRhombus.enum';
import { INGRhombus } from './NGRhombus.type';

export const StyledCrossContainer = styled.div`
	position: absolute;
	z-index: 2;

	display: flex;
	justify-content: center;
	align-items: center;

	width: 100%;
	height: 100%;

	pointer-events: none;
	user-select: none;

	& > span {
		position: absolute;
		width: 50%;
		height: 1px;

		${addTransition()}

		background-color: ${(p) => p.theme.colors.gold};

		opacity: 1;

		&:nth-child(1) {
			transform: rotate(45deg);
		}

		&:nth-child(2) {
			transform: rotate(-45deg);
		}

		${(p) =>
			p.isSelected
				? css`
						background-color: ${p.theme.colors.lead};

						&:nth-child(2) {
							height: 2px;
						}

						&:nth-child(1) {
							width: 0;
							opacity: 0;
						}
				  `
				: ''}
	}
`;

export const StyledRhombus = styled.div<Pick<INGRhombus, 'size'>>`
	display: flex;
	justify-content: center;
	align-items: center;

	position: relative;

	${(p) => `
      background-color: transparent;

      cursor: ${p.as === 'button' && !p.disabled ? 'pointer' : 'default'};

			${addTransition()}
			${p.disabled ? 'opacity: 0.5;' : ''}
  `}

	transform: rotate(45deg);

	border: none;
	padding: 0;

	${(p) => {
		if (!p.size) {
			return '';
		}

		switch (p.size) {
			case ESize.xs:
				return `
          width: 9px;
          height: 9px;
        `;
			case ESize.s:
				return `
          width: 14px;
          height: 14px;
        `;
			case ESize.m:
				return `
          width: 28px;
          height: 28px;
        `;
			case ESize.l:
				return `
          width: 38px;
          height: 38px;
        `;
			case ESize.xl:
				return `
          width: 46px;
          height: 46px;
        `;
			case ESize['2xl']:
				return `
          width: 100px;
          height: 100px;
        `;
			default:
				return ``;
		}
	}}

	& > div:not(${StyledCrossContainer}) {
		display: flex;
		justify-content: center;
		align-items: center;

		position: relative;

		z-index: 1;

		border: 1px solid ${(p) => p.theme.colors.gold};

		${addTransition()}

		& > div {
			${addTransition()}

			& > div {
				${addTransition()}
			}
		}

		${(p) => {
			if (!p.type) {
				return '';
			}

			switch (p.type) {
				case ERhombusType.empty:
					return css`
						width: 100%;
						height: 100%;

						background-color: ${p.theme.colors.transparentBlack};

						& > div {
							width: 100%;
							height: 100%;

							background-color: ${p.theme.colors.transparentBlack};
						}

						${p.as === 'button' && !p.disabled
							? `
							@media (hover: hover) {
								&:hover {
									background-color: ${p.theme.colors.black};

									& > div {
										background-color: ${p.theme.colors.black};
									}
								}
							}
            `
							: ``}
					`;
				case ERhombusType.half:
					return css`
						width: 100%;
						height: 100%;

						background-color: ${p.theme.colors.transparentBlack};

						//border-color: ${p.theme.colors.gold + '00'};

						& > div {
							width: 60%;
							height: 60%;

							background-color: ${p.theme.colors.gold};
						}

						${p.as === 'button' && !p.disabled
							? `
							@media (hover: hover) {
								&:hover {
									background-color: ${p.theme.colors.black};
								}
							}
            `
							: ``}
					`;
				case ERhombusType.full:
					return `
            width: 100%;
            height: 100%;

						background-color: ${p.theme.colors.gold};

            & > div {
              width: 0%;
              height: 0%;

							//background-color: ${p.theme.colors.gold};
            }
        `;
				default:
					return ``;
			}
		}}
	}
`;

export const StyledIcon = styled.span<{
	size: ESize;
	disabled?: boolean;
}>`
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;

	display: flex;
	justify-content: center;
	align-items: center;

	transform: rotate(-45deg);

	text-align: center;
	line-height: 1;

	${addTransition()}

	${(p) => `
    color: ${p.theme.colors.text.white};

		${
			!p.disabled
				? `
				@media (hover: hover) {
					&:hover {
						color: ${p.theme.colors.text.darkGold};
					}
				}
		`
				: ''
		}
  `}

	${(p) => {
		if (!p.size) {
			return '';
		}

		switch (p.size) {
			case ESize.s:
				return `
          font-size: 8px;
        `;
			case ESize.m:
				return `
          font-size: 14px;
        `;
			case ESize.l:
			case ESize.xl:
				return `
          font-size: 22px;
        `;
			case ESize['2xl']:
				return `
          font-size: 40px;
        `;
			default:
				return ``;
		}
	}}
`;

export const StyledWave = styled.span`
	@keyframes waves {
		0% {
			transform: scale(1);
			opacity: 1;
		}
		100% {
			transform: scale(2);
			opacity: 0;
		}
	}

	position: absolute;

	border: 1px solid ${(p) => `${p.theme.colors.gold}`};

	background-color: transparent;

	width: 100%;
	height: 100%;

	z-index: 0;

	&.running {
		&.wave-1 {
			animation: waves 1s ease-out forwards;
		}
		&.wave-2 {
			animation: waves 1s ease-out 0.25s forwards;
		}
	}
`;
